<div class="container-fluid ml-n2">
  <div class="row mt-3">
    <div class="col-12 multiple-container-array-style">
      <div v-for="item in multipleListItems" class="m-2 multiple-function-container function-hover"
        v-on:click="clickItem(item)">
        <div class="function-label text-center">{{item.name}}</div>
      </div>
    </div>
  </div>

  <processing-view :processing="processing"></processing-view>
</div>